const translation = {
  custom: 'Personnalisation',
  upgradeTip: {
    prefix: 'Mettez à niveau votre plan pour',
    suffix: 'personnalisez votre marque.',
    des: 'Mettez à niveau votre plan pour personnaliser votre marque',
    title: 'Améliorez votre plan',
  },
  webapp: {
    title: 'Personnalisez la marque web app',
    removeBrand: 'Supprimer Propulsé par Dify',
    changeLogo: 'Changer Propulsé par l\'Image de Marque',
    changeLogoTip: 'Format SVG ou PNG avec une taille minimum de 40x40px',
  },
  app: {
    title: 'Personnaliser la marque de l\'en-tête de l\'application',
    changeLogoTip: 'Format SVG ou PNG avec une taille minimale de 80x80px',
  },
  upload: 'Télécharger',
  uploading: 'Téléchargement',
  uploadedFail: 'Le téléchargement de l\'image a échoué, veuillez la télécharger à nouveau.',
  change: 'Changer',
  apply: 'Appliquer',
  restore: 'Rétablir les paramètres par défaut',
  customize: {
    contactUs: 'Contactez-nous',
    prefix: 'Pour personnaliser le logo de la marque dans l\'application, s\'il vous plaît',
    suffix: 'pour passer à l\'édition Enterprise.',
  },
}

export default translation
